<template>
   
<div class="flex flex-col shadow">
    <img src="@/assets/images/pages/airfreight.jpg" alt="airfreight-cover" class="object-contain overlay-card h-auto opacity-25 rounded-lg w-full">

</div>
    
</template>

<script>
export default {
    
}
</script>